export const api = {
  GET_INSPECTION_DATA: 'steps/getStep11PDFData'
};
